import eventBus from "../events/eventBus";
import { getQueryParams, registerCloseFunction } from "./helper";

// Function to show alerts using the DasyUI alert component, used accross the application
export function showAlert(message, type, timeout, callback, old = false) {

    const query = getQueryParams();

    if (query.alert == 'false') {
        console.warn(`Alert display is disabled by query parameter.`);
        return;
    }

    let alertContainer = document.getElementById('alerts');

    console.log(`Alert: ${message}, Type: ${type}, Timeout: ${timeout}`);

    if (!alertContainer) {
        alertContainer = createAlertContainer();
    }

    if (query.modal && typeof query.modal == 'string') {
        const modal = document.getElementById(query.modal);
        if (modal) {
            moveAlertContainer(query.modal);
        }
    } else {
        moveAlertContainer();
    }
    const alert = createAlertElement(message, type, old);

    // Add click event to remove alert
    alert.addEventListener('click', () => {
        if (callback) {
            callback();
        }
        alert.remove();
    });

    alertContainer.appendChild(alert);

    // Automatically remove the alert after set timeout or 5 seconds if not clicked
    if (timeout) {
        if (timeout == -1) {
            return;
        }
        setTimeout(() => {
            if (alert.parentNode) {
                alert.remove();
            }
        }, timeout);
    } else {
        setTimeout(() => {
            if (alert.parentNode) {
                alert.remove();
            }
        }, 5000);
    }
}

function createAlertContainer() {
    const alertContainer = document.createElement('div');
    alertContainer.id = 'alerts';
    alertContainer.classList.add('fixed', 'top-9', 'left-7', 'mr-7', 'z-[10000]')
    alertContainer.style.marginTop = '65px';
    document.body.appendChild(alertContainer);
    return alertContainer;
}

export function hasActiveAlerts() {
    const alertContainer = document.getElementById('alerts');
    if (!alertContainer) {
        console.error(`Alert container with id alerts not found.`);
        return false;
    }
    const alerts = alertContainer.getElementsByClassName('alert');
    if (alerts.length > 0) {
        return true;
    } else {
        return false;
    }
}

eventBus.on('modal:open', (data) => {
    moveAlertContainer(data.modalId)
});

eventBus.on('modal:close', (data) => {
    moveAlertContainer()
});

export function moveAlertContainer(modalId) {
    const containerElement = modalId ? document.getElementById(modalId) : document.getRootNode().body;
    let alertContainer = document.getElementById('alerts');
    if (!alertContainer) {
        createAlertContainer();
    }

    containerElement.appendChild(alertContainer);
}

function createAlertElement(message, type, old = false) {
    if (old) {
        const alert = document.createElement('div');
        const msg = document.createElement('span');

        if (!type) {
            type = 'info';
        }

        alert.role = 'alert';
        alert.classList.add('alert');
        alert.classList.add(`alert-${type}`);
        alert.classList.add('cursor-pointer');
        alert.classList.add('flex');
        alert.classList.add('max-w-full')
        
        if (type === 'error') {
            alert.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
        } else if (type === 'info' || type === 'warning') {
            alert.innerHTML = '<i class="fas fa-info-circle"></i>';
        } else if (type === 'success') {
            alert.innerHTML = '<i class="fas fa-check-circle"></i>';
        }

        if (type == 'warning') {
            alert.classList.add('bg-warning');
            alert.classList.add('text-black');
            alert.classList.add('border-warning');
        }

        msg.innerHTML = message;
        alert.appendChild(msg);
        return alert;
    }

    const alert = document.createElement('div');
    const container = document.createElement('div');
    const textContainer = document.createElement('div');
    const msg = document.createElement('strong');
    const close = document.createElement('button');

    if (!type) {
        type = 'info';
    }

    alert.role = 'alert';
    alert.classList.add('rounded-xl', 'border', 'border-gray-100', 'bg-white', 'p-4', 'mb-3');

    container.classList.add('flex', 'items-start', 'gap-4');

    if (type == 'error') {
        container.innerHTML = '<i class="fa-regular fa-circle-xmark text-error text-3xl"></i>';
        alert.classList.add('border-s-4', 'border-error', 'bg-red-50');
    } else if (type == 'info' || type == 'warning') {
        alert.classList.add('border-s-4', 'border-warning');
        container.innerHTML = '<i class="fa-solid fa-info text-warning text-2xl"></i>';
    } else if (type == 'success') {
        alert.classList.add('border-s-4', 'border-l-success');
        container.innerHTML = '<i class="fa-regular fa-check-circle text-success text-3xl"></i>';
    }

    textContainer.classList.add('flex-1');
    msg.classList.add('mt-1', 'text-sm', 'text-gray-700')
    msg.innerHTML = message;
    close.classList.add('text-gray-500', 'transition', 'hover:text-gray-600', 'cursor-pointer');
    close.innerHTML = '<span class="sr-only">Dismiss popup</span><i class="fas fa-times"></i>';

    alert.appendChild(container);
    container.appendChild(textContainer);
    textContainer.appendChild(msg);
    container.appendChild(close);

    close.addEventListener('click', () => {
        alert.remove();
    });
    
    return alert;
}